import Payload from "@/lib/models/payload.js"

const state = {
  cities: [],
  states: [],
  contract: {
    TcciTexto: null,
  },
  clauses: {},
  businessPlans: [],
  plans: [
    { 
      description: 'One Business',
      value: 'business',
      pricing: 99.90,
      anualPricing: 89.90,
      features: [
        'Crie até <b>10 Automações no Task</b>',
        'Crie até <b>10 Formulários no React</b>',
        'Receba até <b>100 respostas nos formulários do React</b>',
        'Chat integrado <b>Echo</b> para toda a equipe para conversas individuais',
        'Até <b>30 documentos</b> por mês no <b>Analyser</b>',
        '<b>10 Gb</b> de armazenamento por usuário',
        'Conte com a implantação da TARS'
      ]
    },
    {
      description: 'One Plus',
      value: 'plus',
      pricing: 129.90,
      anualPricing: 109.90,
      features: [
        
      ]
    }
  ],
  UserCode: null,
  cardType: null,
  userExists: false,
  checkoutMessage: "",
  checkoutOk: null,
  ip: null
};

const mutations = {
  SET_DATA(state, payload) {
    eval("this.state.signup." + payload.selection + " = payload.data;");
  },

  SET_STATE(state, choosenState) {
    this.state.signup.state = choosenState;
  },

  SET_IP(state, ip) {
    this.state.signup.ip = ip;
  },

  SET_CITIES(state, choosenCities) {
    this.state.signup.choosenCities = choosenCities;
  },

  SET_CITY(state, choosenCity) {
    this.state.signup.city = choosenCity;
  },

  SET_CARD_TYPE(state, type) {
    this.state.signup.cardType = type;
  },

  SET_TRANSACTION_RESULT(stat, transactionResult) {
    this.state.signup.user.Transaction = transactionResult
  },

  SET_USER_EXISTS(state, userExists) {
    this.state.signup.userExists = userExists
  },

  SET_CHECKOUT_MESSAGE(state, message) {
    this.state.signup.checkoutMessage = message
  },

  SET_CHECKOUT_OK(state, checkoutOK) {
    this.state.signup.checkoutOk = checkoutOK
  }
};

const actions = {
  //used to get cities and states from the api
  async populateSignupData({
    dispatch,
    commit
  }, opt) {

    await dispatch(
        "caller/fetchData", {
          url: "SignUp/get" +
            opt.selection.toString().replace(/./, (x) => x.toUpperCase()),
          method: "post",
          dispatcher: "signup/populateSignupData",
          selection: opt.selection,
        }, {
          root: true
        }
      )
      .then((promise) => {
        if (promise !== undefined) {
          let payload = new Object();
          payload.selection = opt.selection;
          payload.data = promise.Result;
          commit("SET_DATA", payload);
        }
      })
      .catch(() => {});
  },

  chooseState({
    commit
  }, state) {
    commit("SET_STATE", state);
  },

  chooseCities({
    commit
  }, state) {
    commit("SET_CITIES", state);
  },

  chooseCity({
    commit
  }, state) {
    commit("SET_CITY", state);
  },

  setCheckoutMessage({
    commit
  }, state) {
    commit("SET_CHECKOUT_MESSAGE", state)
  },

  getBusinessPlans({
    dispatch,
    commit
  }, opt) {
    dispatch(
        "caller/fetchData", {
          error: opt.error || "000",
          url: "BusinessPlan/Get",
          dispatcher: "signup/getBusinessPlans",
          method: "post"
        }, {
          root: true
        }
      )
      .then((promise) => {
        if (promise !== undefined) {
          commit("SET_DATA", new Payload("businessPlans", promise.Result.list));
        }
      })
      .catch(() => {});
  },

  getContract({
    dispatch,
    commit
  }, opt) {
    dispatch(
        "caller/fetchData", {
          error: opt.error || "000",
          url: "Terms/Get",
          dispatcher: "signup/getContract",
          method: "post"
        }, {
          root: true
        }
      )
      .then((promise) => {
        if (promise !== undefined) {
          commit("SET_DATA", new Payload("contract", promise.Result.list[0]));
          dispatch("getClauses", {
            api: opt.api,
            data: promise.Result.list[0].TciID

          });
        }
      })
      .catch(() => {});
  },

  getClauses({
    dispatch,
    commit
  }, opt) {
    dispatch(
        "caller/fetchData", {
          error: opt.error || "000",
          url: "Terms/GetClauses",
          dispatcher: "signup/getClauses",
          method: "post",
          data: {
            pTciID: opt.data
          },
        }, {
          root: true
        }
      )
      .then((promise) => {
        if (promise !== undefined) {
          commit("SET_DATA", new Payload("clauses", promise.Result.list[0]));
        }
      })
      .catch(() => {});
  },

  async getUserCode({
    dispatch,
    commit
  }) {
    await dispatch(
        "caller/fetchData", {
          url: "Payment/GetPaymentProfileCode",
          dispatcher: "signup/getUserCode",
          method: "post"
        }, {
          root: true
        }
      )
      .then((promise) => {
        if (promise !== undefined) {
          commit("SET_DATA", new Payload("UserCode", promise.Result));
        }
      })
      .catch(() => {});
  },

  //set user opt in state
  setUser({ commit }, user) {

    commit("SET_DATA", new Payload("user", user));

  },

  async setIP({ commit }) {

    let ip = require("request-ip");
    
    commit("SET_DATA", new Payload("ip", ip.address));
    
  },

  // Done on Internal API
  async checkout({ dispatch, commit }) {

    await dispatch(
      "caller/fetchData", {
        dispatcher: "signup/checkout",
        data: {
          json: JSON.stringify(state.user)
        },
        method: "post",
        url: "SignUp/Checkout"
      }, {
        root: true
      }
    ).then(async (promise) => {
        
      
      if (promise != undefined) {
        
          commit("SET_CHECKOUT_MESSAGE",'Tudo certo! Aguarde enquanto preparamos o Task para você.');
          commit("SET_TRANSACTION_RESULT", JSON.parse(promise.Result));
          commit("SET_CHECKOUT_OK", true)

          await dispatch("changeBlankDB"); 
        } else {

          commit("SET_CHECKOUT_MESSAGE",'');                    
          commit("SET_CHECKOUT_OK", false)

        }dispatch(
        "getUserCode"
      )
      });
  },

  async changeBlankDB({ dispatch, commit }) {
    
    commit("SET_CHECKOUT_MESSAGE",
      `Tudo certo! Aguarde enquanto preparamos tudo para você.`);

    commit("SET_CHECKOUT_OK", true)

    await dispatch(
      "caller/fetchData", {
        dispatcher: "signup/changeBlankDB",
        data: {
          json: JSON.stringify(state.user)
        },
        method: "post",
        url: "SignUp/Signup",
      }, {
        root: true
      }
    ).then((promise) => {
      
      if (promise != undefined) {

        commit("SET_CHECKOUT_MESSAGE",'Tudo pronto! Você será redirecionado.');

        // window.gtag_report_conversion(promise.Result.link)

        location.href = `${promise.Result.link}`

      } else {

        commit("SET_CHECKOUT_MESSAGE",'');                    
        commit("SET_CHECKOUT_OK", false)

      }
      
    });
  },

  async checkUserExists({ dispatch, commit }, opt) {

    await dispatch(
      "caller/fetchData", {
        dispatcher: "signup/checkUserExists",
        data: {
          pEmail: opt.userMail
        },
        method: "post",
        url: "account/exists"
      }, {
        root: true
      }
    ).then((promise) => {
      if (promise != undefined) {
        commit("SET_USER_EXISTS", promise.Result)
      }
    })
  }  
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};